import { createRouter, createWebHistory } from "vue-router"
import Home from "../views/Home.vue"
import NotFound from "../views/NotFound.vue"
import ProjectDetails from "../views/ProjectDetails.vue"
import PrivacyPolicy from "../views/PrivacyPolicy.vue"
import TermsConditions from "../views/TermsConditions.vue"
import Contact from "../views/Contact.vue"

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/app/:appName',
        name: 'ProjectDetails',
        component: ProjectDetails,
        props: true
    },
    {
        path: '/privacy-policy/:appName',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy,
        props: true
    },
    {
        path: '/terms-conditions/:appName',
        name: 'TermsConditions',
        component: TermsConditions,
        props: true
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/not-found',
        component: NotFound
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: NotFound
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router